<template>
<router-view></router-view>
</template>

<script>
export default {
    name: "BillingPage"
}
</script>

<style scoped>

</style>